<div class="d-flex flex-column h-100 overflow-hidden">
  <lib-chat-message-list class="flex-grow-1 min-h-0" [messages]="messages()" [showCursor]="showCursor()" />

  <lib-chat-error-banner [errorMessage]="visibleError()" (retry)="onErrorRetry()" (dismiss)="onErrorDismiss()" />

  <app-debug-mock-panel />

  <div class="d-flex flex-column gap-1 px-3 py-2">
    @if (currentEntry(); as entry) {
      <!-- Progress indicator — only when N > 1 -->
      @if (showProgress()) {
        <p class="mat-font-label-sm mat-text-on-surface-variant mb-0">
          Step {{ currentStep() }} of {{ totalEntries() }}
        </p>
      }

      <!-- Active clarification card -->
      @switch (entry.kind) {
        @case ('boolean') {
          <app-hitl-confirm-card [entry]="entry" (submitted)="onHitlSubmit($event)" />
        }
        @case ('select') {
          <app-hitl-selection-card [entry]="entry" (submitted)="onHitlSubmit($event)" />
        }
        @case ('multiselect') {
          <app-hitl-selection-card [entry]="entry" (submitted)="onHitlSubmit($event)" />
        }
        @default {
          <!-- text, date, number, geocoding, geometry -->
          <app-hitl-form-card [entry]="entry" (submitted)="onHitlSubmit($event)" (cancelled)="onHitlCancel()" />
        }
      }
    } @else if (hitlService.frontendToolsPayload(); as ftPayload) {
      <app-hitl-tool-call-card [displayText]="ftPayload.display_text" [items]="ftPayload.items" />
    }
  </div>

  <app-background-job-panel class="px-3" />

  <lib-chat-input class="flex-shrink-0" [isLoading]="showCursor()" />
</div>
